import { dramas } from "@/mocks/dramas";
import type { Drama, DramaFilter, SortKey } from "@/types/drama";

export const PAGE_SIZE = 9;

export const allDramas = dramas as Drama[];

export const GENRES = ["全部", "都市", "职场", "情感", "悬疑", "家庭", "年代", "励志"];
export const REGIONS = ["全部", "内地", "香港", "台湾", "韩国", "日本"];
export const YEARS = ["全部", "2024", "2023", "2022", "2021"];

export const SORT_OPTIONS: { key: SortKey; label: string }[] = [
  { key: "update", label: "最近更新" },
  { key: "heat", label: "热度最高" },
  { key: "rating", label: "评分最高" },
];

export function getDramaById(id: string | undefined): Drama | undefined {
  if (!id) return undefined;
  return allDramas.find((item) => item.id === id);
}

export function filterDramas(filter: DramaFilter, sort: SortKey): Drama[] {
  const result = allDramas.filter((item) => {
    const genreOk = !filter.genre || filter.genre === "全部" || item.genres.includes(filter.genre);
    const regionOk = !filter.region || filter.region === "全部" || item.region === filter.region;
    const yearOk = !filter.year || filter.year === "全部" || String(item.year) === filter.year;
    return genreOk && regionOk && yearOk;
  });

  return result.sort((a, b) => {
    if (sort === "heat") return b.heat - a.heat;
    if (sort === "rating") return b.rating - a.rating;
    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
  });
}

export function searchDramas(keyword: string): Drama[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return allDramas.filter((item) => {
    const haystack = [item.title, item.director, ...item.cast, ...item.genres, ...item.tags]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function getRecommendations(drama: Drama, limit = 4): Drama[] {
  const related = allDramas.filter(
    (item) => item.id !== drama.id && item.genres.some((g) => drama.genres.includes(g)),
  );
  const sorted = related.sort((a, b) => b.heat - a.heat);
  if (sorted.length >= limit) return sorted.slice(0, limit);
  const filler = allDramas
    .filter((item) => item.id !== drama.id && !sorted.includes(item))
    .sort((a, b) => b.heat - a.heat);
  return [...sorted, ...filler].slice(0, limit);
}

export function getEpisodeList(drama: Drama) {
  return Array.from({ length: Math.min(drama.totalEpisodes, 60) }, (_, index) => ({
    index: index + 1,
    label: `第 ${index + 1} 集`,
    isNew: index + 1 > drama.updatedEpisodes,
  }));
}

export function formatDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return `${date.getMonth() + 1} 月 ${date.getDate()} 日`;
}